module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-area",
    class: _vm.cls
  }, [_c('div', {
    staticClass: "add-comment"
  }, [(_vm.creatingComment) ? _c('textarea', {
    ref: "newcommenttext",
    attrs: {
      "id": "",
      "cols": "30",
      "rows": "3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.creatingComment) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cancelCreateComment()
      }
    }
  }, [_vm._v("Annullér")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.createComment()
      }
    }
  }, [_vm._v("Tilføj")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "comments-list"
  }, _vm._l((_vm.comments), function(c, c_i) {
    return _c('div', {
      key: 'c' + c_i,
      staticClass: "comment"
    }, [_c('avatar', {
      attrs: {
        "input": c.user
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "before"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n          " + _vm._s(c.user.first_name) + " " + _vm._s(c.user.last_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "created"
    }, [_vm._v("\n          " + _vm._s(c.created_human2) + "\n          (\n            " + _vm._s(c.created_human) + "\n            "), (c.edited) ? [_vm._v("\n              — Redigeret\n            ")] : _vm._e(), _vm._v("\n          )\n        ")], 2)]), _vm._v(" "), (_vm.editing_comment_i != c_i) ? _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.nl2br(c.text))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editing_comment_i == c_i) ? _c('div', {
      staticClass: "edit-comment"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editing_comment_text),
        expression: "editing_comment_text"
      }],
      attrs: {
        "cols": "30",
        "rows": "3"
      },
      domProps: {
        "value": (_vm.editing_comment_text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editing_comment_text = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.editing_comment_i = undefined
        }
      }
    }, [_vm._v("Annullér")]), _vm._v(" "), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.saveEditedComment()
        }
      }
    }, [_vm._v("Gem")])]) : _vm._e(), _vm._v(" "), (_vm.editing_comment_i != c_i) ? _c('div', {
      staticClass: "after"
    }, [(c.can_edit) ? _c('div', {
      staticClass: "edit-btn",
      on: {
        "click": function($event) {
          return _vm.setEditingComment(c, c_i)
        }
      }
    }, [_vm._v("Redigér")]) : _vm._e(), _vm._v(" "), (c.can_delete) ? _c('div', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          return _vm.archiveComment(c)
        }
      }
    }, [_vm._v("Slet")]) : _vm._e()]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-290f480c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comments.vue
// module id = 589
// module chunks = 1